export default __webpack_public_path__ + "../img/0f6ef09166485223796a35ae5f5b86ab.png";